import type { TableWidget } from '@piccolohealth/pbs-common';
import { ChakraV3, ScrollArea } from '@piccolohealth/ui';
import React from 'react';
import { FaPlus } from 'react-icons/fa';

import { FormSection } from '../../../../components/forms/FormSection';
import { FormStack } from '../../../../components/forms/FormStack';
import type { UseTableReturn } from '../../hooks/useTable';
import { TableSeriesList } from './TableSeriesList';

interface Props {
  table: UseTableReturn;
  onSubmit: (value: TableWidget) => void;
}

export const TableWidgetModalSidebar = (props: Props) => {
  const { table, onSubmit } = props;

  return (
    <ChakraV3.Stack w='390px' h='full' gap={4} flexShrink={0}>
      <ScrollArea h='full'>
        <FormStack p={4}>
          <FormSection heading='Basic details' description='Set the basic details of the table'>
            <ChakraV3.FormField label='Table title'>
              <ChakraV3.Input
                value={table.widget.title}
                onChange={(e) => table.onSetTitle(e.target.value)}
                size='sm'
                placeholder='Enter table title'
              />
            </ChakraV3.FormField>
          </FormSection>

          <ChakraV3.Separator />

          <FormSection heading='Behaviours' description='Select the behaviours you want to view'>
            <TableSeriesList table={table} />
          </FormSection>

          <ChakraV3.Separator />

          <ChakraV3.Spacer />
        </FormStack>
      </ScrollArea>
      <ChakraV3.Stack px={4} pb={4}>
        <ChakraV3.Button onClick={() => onSubmit(table.widget)} size='sm' colorPalette='brand'>
          <FaPlus />
          Save
        </ChakraV3.Button>
      </ChakraV3.Stack>
    </ChakraV3.Stack>
  );
};
